import { defineMessages } from 'react-intl';
export default defineMessages({
    updateAvailable: {
        id: 'appUpdate.updateAvailable',
        defaultMessage: 'Update available'
    },
    updateAvailableOpenAppStore: {
        id: 'appUpdate.updateAvailableOpenAppStore',
        defaultMessage: 'Tap to open the App Store'
    },
    updateAvailableOpenGooglePlay: {
        id: 'appUpdate.updateAvailableOpenGooglePlay',
        defaultMessage: 'Tap to open Google Play'
    },
    updateAvailableVersion: {
        id: 'appUpdate.updateAvailableVersion',
        defaultMessage: 'Update available: v{version}'
    },
    upgradeRequiredAndroid: {
        id: 'appUpdate.upgradeRequiredAndroid',
        defaultMessage: 'An upgrade of your application is required. Visit Google Play to upgrade.'
    },
    upgradeRequiredIos: {
        id: 'appUpdate.upgradeRequiredIos',
        defaultMessage: 'An upgrade of your application is required. Visit the App Store to upgrade.'
    }
});
